import React from 'react'

function Map(props) {
  const search = `https://maps.google.com/maps?q=${props.address}&t=&z=16&ie=UTF8&iwloc=&output=embed`
  const height = window.innerHeight*0.8;

  return (
    <div className="mapouter">
      <div className="gmap_canvas">
        <iframe
          title={props.address}
          src={search}
          width="100%"
          height = {height}
          id="gmap_canvas"
          frameBorder="0"
          scrolling="no"
          marginHeight="0"
          marginWidth="0"
        />
      </div>
    </div>
  )
}

export default Map
